module.exports = __webpack_public_path__ + "img/system.0a7e6901.jpg";